import { InputField } from "components/InputField/Input";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useProductDataTable = (formik) => {
    const addProductOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`order_items[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const { brandDropdown, setBrandDropdown, brandList} = useItemDropdown();

    const modalTableColumns = [
        {
            field: "name",
            header: "Name",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="name"
                        name="name"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "name")}
                        value={formik.values.order_items[event.rowIndex]?.name}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.name}
                    />
                </div>
            ),
        },
        {
            field: "uom",
            header: "UOM",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="uom"
                        name="uom"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "uom")}
                        value={formik.values.order_items[event.rowIndex]?.uom}
                        type="text"
                        width="full"
                        autoCompleteFieldName="uom"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.uom}
                    />
                </div>
            ),
        },
        {
            field: "brand",
            header: "Brand",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField
                        id="brand"
                        name="brand"
                        autoFilteredValue={brandDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setBrandDropdown, brandList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "brand")}
                        value={formik.values.order_items[event.rowIndex]?.brand}
                        type="select"
                        label="Select Brand"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        errors={formik.errors.order_items?.[event.rowIndex]?.brand?.id}
                    />
                </div>
            ),
        },
        {
            field: "order_quantity",
            header: "Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="order_quantity"
                        name="order_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "order_quantity")}
                        value={formik.values.order_items[event.rowIndex]?.order_quantity}
                        type="text"
                        width="full"
                        autoCompleteFieldName="order_quantity"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.order_quantity}
                    />
                </div>
            ),
        },
        {
            field: "unit_price",
            header: "Unit Price",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="unit_price"
                        name="unit_price"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "unit_price")}
                        value={formik.values.order_items[event.rowIndex]?.unit_price}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="unit_price"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.unit_price}
                    />
                </div>
            ),
        },
        {
            field: "discount",
            header: "Discount",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="discount"
                        name="discount"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "discount")}
                        value={formik.values.order_items[event.rowIndex]?.discount || 0}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="discount"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.discount}
                    />
                </div>
            ),
        },
        {
            field: "total_unit_price",
            header: "Total unit price",
            sortableBody: (value, event) => (
                <div className="w-25" style={{"textAlign": "center"}}>
                    <span style={{"color": "#203225"}}>
                        {parseFloat((formik.values.order_items[event.rowIndex]?.order_quantity * formik.values.order_items[event.rowIndex]?.unit_price) - (formik.values.order_items[event.rowIndex]?.discount || 0)).toFixed(3)}
                    </span>
                </div>
            ),
        },
    ]

    return {
        modalTableColumns,
    }
}

export default useProductDataTable